import FAQ from "../shared/FAQ/FAQ";
import ConsultingHero from "../shared/ConsultingHero/ConsultingHero";
import AssociatedServices from "../shared/AssociatedServices/AssociatedServices";
import ServiceIntro from "../shared/ServiceIntro/ServiceIntro";
import CTABanner from "../shared/CTABanner/CTABanner";
import ImpactStatsSection from "../shared/ImpactStatsSection/ImpactStatsSection";
import {
  googleAdFaqs,
  googleAdExpertise,
  googleAdHowItWorks,
  googleAdAssociatedServices,
  googleAdImpactStats,
} from "./data/consultingData";

const GoogleAdWordsService = () => {

  return (
    <div>
      <ConsultingHero
        title={
          <>
            <span className="block">$10K/month in</span>
            <span className="block">free Google Ads</span>
          </>
        }
        buttonText="Check My Nonprofit's Eligibility"
        buttonTo="/contact-us"
        bgColor="bg-orange"
        imageSrc="https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/french-bulldog-hero-480.webp"
        imageSrcSet="
          https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/french-bulldog-hero-480.webp 480w,
          https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/french-bulldog-hero-1280.webp 1280w,
          https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/french-bulldog-hero-1920.webp 1920w
        "
        imageAlt="A French bulldog in a yellow sweater"
        imageClassName="lg:object-[center_20%] xl:object-[center_-5%]"
      />

      <ServiceIntro
        title="Google-Certified Experts for Animal Nonprofits"
        description={
          <>
            As the #1 recommended Google Ad Grant agency for animal rescues and
            shelters, we help you reach more adopters, donors, and volunteers—
            <strong>without spending a dollar on ads.</strong>
          </>
        }
        rightCircleSrc="https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/right-circle-group.svg"
      />

      {/* Our expertise section */}
      <section className="bg-blue my-16 py-16 px-4 md:px-8 lg:px-16 xl:px-24">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12 text-center md:text-left">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-black mb-4">
              Our expertise
            </h2>
            <p className="text-sm md:text-base !font-medium max-w-lg mx-auto md:mx-0">
              We make Google Ad Grant management easier than ever! Our services
              cover every aspect of the process, so you can sit back and relax.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {googleAdExpertise.map((item, index) => (
              <div
                key={index}
                className="bg-blue-navy rounded-2xl p-8 lg:p-10 flex flex-col text-white text-left xl:min-h-[620px]"
              >
                <h3 className="font-bold text-2xl lg:text-3xl xl:text-5xl mb-6">
                  {item.title}
                </h3>
                <img
                  src="https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/white-horizontal-line.svg"
                  alt=""
                  className="w-14 xl:w-24 mt-4 mb-12"
                />
                <p className="text-sm lg:text-base xl:text-lg leading-relaxed flex-grow mb-8">
                  {item.description}
                </p>
                <img
                  src={item.image}
                  alt={`${item.title} icon`}
                  className="w-32 lg:w-40 xl:w-64 self-center my-8"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How it works section */}
      <section className="px-4 md:px-8 lg:px-16 xl:px-24 my-16 lg:my-24">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row gap-8 lg:gap-16">
          <div className="md:w-1/2 overflow-hidden rounded-2xl xl:min-h-[700px]">
            <img
              src="https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/how-it-works.png"
              alt="How it works"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="md:w-1/2 flex flex-col justify-center">
            <img
              src="https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/horizontal-line.svg"
              alt=""
              className="w-28 md:w-40 mx-auto md:mx-0 mb-4"
            />
            <h2 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-blue-dark1 mb-4 text-center md:text-left">
              How it works
            </h2>
            <p className="text-sm md:text-base leading-relaxed mb-8 text-center md:text-left">
              Each of our consulting areas below focuses on a different part of
              your nonprofit's growth — from fundraising & awareness to
              operations & digital strategy.
            </p>

            <div className="flex flex-col gap-6">
              {googleAdHowItWorks.map((item, index) => (
                <div key={index} className="flex flex-col items-center md:items-start md:flex-row gap-4 md:gap-8">
                  <div className="w-10 h-10 min-w-[40px] rounded-[50%_50%_5px_50%] bg-orange flex items-center justify-center mt-1">
                    <img
                      src={item.image}
                      alt=""
                      className="w-5 h-5"
                    />
                  </div>
                  <div>
                    <h3 className="font-bold text-blue-dark1 text-lg mb-1 text-center md:text-left">
                      {item.title}
                    </h3>
                    <p className="text-xs lg:text-sm leading-relaxed text-center md:text-left">
                      {item.details}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <ImpactStatsSection
        bgColor={googleAdImpactStats.bgColor}
        title={googleAdImpactStats.title}
        description={googleAdImpactStats.description}
        image1Src={googleAdImpactStats.image1Src}
        image1Alt={googleAdImpactStats.image1Alt}
        image2Src={googleAdImpactStats.image2Src}
        image2Alt={googleAdImpactStats.image2Alt}
        stats={googleAdImpactStats.stats}
        buttonText={googleAdImpactStats.buttonText}
        buttonTo={googleAdImpactStats.buttonTo}
        buttonColour={googleAdImpactStats.buttonColour}
      />

      <CTABanner
        bgColor="bg-orange-dark1"
        overlayFrom="from-orange-dark1 via-orange-dark1/80"
        imageSrc="https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/french-bulldog1.webp"
        imageClassName="object-right xl:translate-x-60"
        title="Turn Google searches into new donors & adopters"
        description="We'll handle your Google Ad Grant from setup to success—so you can stay focused on your mission."
        buttonText="Get Started"
        buttonTo="/contact-us"
      />

      <AssociatedServices
        subtitle="More ways to grow your audience."
        services={googleAdAssociatedServices}
      />

      <FAQ subtitle="About Google Ad Grants" faqs={googleAdFaqs} />
    </div>
  );
};

export default GoogleAdWordsService;
